import { ReactComponent as Remove } from 'assets/icons/icon-remove.svg';

export default Remove;